export default __webpack_public_path__ + "static/media/CENTURY Logo3.621dff72.png";